import { Badge, Flex, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { getKindBadgeColor, getKindPretty, sortKinds } from 'components/tables/data/kind';
import { RevisionTemplateRow } from 'components/tables/data/revision-template/types';

/**
 * Column for the revision template kind.
 */
export default function RevisionTemplateKindColumn({ data: { kinds } }: { data: RevisionTemplateRow }) {
  if (kinds.length === 0) {
    return (
      <Flex
        align="center"
        gap={6}
        px={8}
        py={4}
        bg="#FFF4E6"
        sx={{ border: '1px solid #F08C00', borderRadius: '999px', width: 'fit-content' }}
      >
        <IconAlertTriangle size={16} color="#E67700" />
        <Text size="xs" c="#9C5C00" fw={500}>
          Bez typu
        </Text>
      </Flex>
    );
  }

  return (
    <Flex gap={8} wrap="wrap">
      {sortKinds(kinds).map((kind) => (
        <Badge key={kind} color={getKindBadgeColor(kind)} size="sm" variant="filled">
          {getKindPretty(kind)}
        </Badge>
      ))}
    </Flex>
  );
}
